import { user, signIn, signOut, listen, signUp, restore } from '../services/auth.service'

export class LoginDialog extends HTMLElement {
  constructor() {
    super();
    listen(() => this.checkStatus())
  }

  close() {
    return this.parentNode.removeChild(this)
  }

  submit() {
    const email = this.querySelector('input[type=email]').value

    if (this.mode === 'login') {
      const password = this.querySelector('input[type=password]').value
      signIn(email, password)
      .catch(error => {
        this.querySelector('button[type=submit]').removeAttribute('disabled')
        this.querySelector('.error').innerHTML = error.message
      })
    } else if (this.mode === 'signup') {
      const password = this.querySelector('input[type=password]').value
      signUp(email, password)
      .catch(error => {
        this.querySelector('button[type=submit]').removeAttribute('disabled')
        this.querySelector('.error').innerHTML = error.message
      })
    } else if (this.mode === 'restore') {
      restore(email)
      .catch(error => {
        this.querySelector('button[type=submit]').removeAttribute('disabled')
        this.querySelector('.error').innerHTML = error.message
      })
    }
  }

  checkStatus() {
    if (user.value) {
      this.close()
    } else {
      this.querySelector('button[type=submit]').removeAttribute('disabled')
    }
  }

  onChange() {
    const email = this.querySelector('input[type=email]').value
    const password = this.querySelector('input.password[type=password]')
    const cpassword = this.querySelector('input.confirm-password[type=password]')

    let ok = false
    if (cpassword) {
      ok = password.value === cpassword.value && password.value && email
    } else if (password) {
      ok = password.value && email
    } else {
      ok = email
    }

    if (ok) {
      this.querySelector('button[type=submit]').removeAttribute('disabled')
      this.querySelector('.error').innerHTML = ''
    } else {
      this.querySelector('button[type=submit]').setAttribute('disabled', '')
    }
  }

  mode = 'login'
  handleEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.srcElement.classList.contains('e:close')) {
      return this.close()
    }
    if (event.srcElement.classList.contains('e:submit')) {
      event.srcElement.setAttribute('disabled', '')
      return this.submit()
    }
    if (event.srcElement.classList.contains('e:signup')) {
      this.mode = this.mode === 'login' ? 'signup' : 'login'
      return this.connectedCallback()
    }
    if (event.srcElement.classList.contains('e:recover')) {
      this.mode = 'restore'
      return this.connectedCallback()
    }
    if (event.type === 'input') {
      this.onChange()
    }
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        #login-dialog {
          max-width: min(420px, 80vw);
          position: absolute;
          margin-left: auto;
          margin-right: auto;
          left: 0;
          right: 0;
          text-align: center;
        }
        dialog::backdrop {
          background: repeating-linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.4),
            rgba(0, 0, 0, 0.4) 1px,
            rgba(0, 0, 0, 0.6) 1px,
            rgba(0, 0, 0, 0.6) 20px
          );
        }
        #login-dialog {
          display: block;
          min-width: 280px;
          background: #232323;
          color: white;
          padding: 0;
          position: relative;
          overflow: hidden;
          border-radius: var(--border-radius-v2);

          padding: 0 15px 20px 15px;
          box-shadow: 0 0 10px #232323;
          border: 1px solid #232323;
          transform: translateZ(0);
          background: linear-gradient(180deg, #232323, #111)

        }
        #login-dialog .close-dialog {
          font-size: 22px;
          color: white;
          text-shadow: 0 0 2px black;
        }
        #login-dialog h2 {
          font-weight: 400;
          font-size: 24px;
          margin-bottom: 0;
        }
        #login-dialog .btn-grad {
          border: 1px solid #232323;
        }
        #login-dialog .large {
          font-size: 16px;
          padding: 8px 20px;
        }
        button:disabled {
          opacity: .5;
          filter: grayscale(1);
        }
        #login-dialog label {
          display: block;
        }
        #login-dialog .error {
          color: coral;
        }
        #login-dialog .btn-clear {
          border: none;
          background: transparent;
          color: white;
        }
        #login-dialog .color-orange {
          color: #fa4804;
        }
      </style>
      <dialog id="login-dialog">
        <section>
          ${this.mode === 'signup' ? '<h1>Sign up</h1>' : ''}
          ${this.mode === 'login' ? '<h1>Login</h1>' : ''}
          ${this.mode === 'restore' ? '<h1>Restore password</h1>' : ''}
          <button class="mapboxgl-popup-close-button click e:close" type="button" aria-label="Close popup" aria-hidden="true">×</button>
          <form>
            <input type="email" placeholder="Email" class="search-input my-10 onchange">
            ${this.mode !== 'restore' ? `<input type="password" placeholder="Password" class="password search-input my-10 onchange">` : ''}
            ${this.mode === 'signup' ? `<input autocomplete="off" type="password" placeholder="Password confirmation" class="confirm-password search-input my-10 onchange">` : ''}
            <label class="error"></label>
            ${this.mode === 'signup' ? `<button type="submit" class="large btn-grad my-10 click e:submit">Sign up</button>` : ''}
            ${this.mode === 'login' ? `<button type="submit" class="large btn-grad my-10 click e:submit">Login</button>` : ''}
            ${this.mode === 'restore' ? `<button type="submit" class="large btn-grad my-10 click e:submit">Send email</button>` : ''}


            ${this.mode === 'login' ? `<label>
              <small>
                <button class="btn-clear color-orange click e:recover">Restore password</button>
              </small>
            </label>` : ''}
            ${this.mode === 'login' ? `<label>
              <small>
                Don't have an account?
                <button class="btn-clear color-orange click e:signup">Sign up</button>
              </small>
            </label>` : ''}
            ${this.mode === 'signup' ? `<label>
              <small>
                Do you have an account?
                <button class="btn-clear color-orange click e:signup">Login</button>
              </small>
            </label>` : ''}
          </form>
        </section>
      </dialog>
    `
    this.querySelectorAll('.click').forEach(node => node.addEventListener("click", this))
    this.querySelectorAll('.onchange').forEach(node => node.addEventListener("input", this))

    this.querySelector('#login-dialog').showModal()
  }
}

window.customElements.define("login-dialog", LoginDialog);
